import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { BrowserRouter, Route ,Switch ,Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
//import * as actionsType from './../actions/types.js';
import * as actionsCreators from './../actions/index.js';
import LogIn from './logIn/logIn.js';
import Spinner from './displayHelpers/spinner/Spinner.js';
import Customers from './candidates/Customers.js';
import SendMassage from './sendMassage/sendMassage.js';
import EmailAutomation from './emailAutomation/emailAutomation.js';
import TagManager from './tagManager/TagManager.js';
import CardcomManagement from './cardcomManagement/cardcomManagement.js';
import AdminDashboard from './adminDashboard/AdminDashboard.js';
import EventTracking from './eventTracking/EventTracking.js';
import WhatsappManagement from './whatsappManagement/WhatsappManagement.js';
import AiInsert from './aiInsert/AiInsert.js';
import AlertMsg from './displayHelpers/alertMsg/alertMsg.js';

// New UI kit (see client/UI_GUIDE.md): UiProvider = theme/RTL/Hebrew, AppLayout = side menu shell.
import UiProvider from '../ui/UiProvider';
import AppLayout from '../ui/AppLayout';

const App = (props) => {

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
     props.fetchUser();
  },[]);

  return (
    <UiProvider>
      <div style={{overflowX: "clip"}} id="app">
        <BrowserRouter>
          <div>
            <Spinner/>
            <SendMassage/>
            <AlertMsg/>
            <AppLayout>
            {/* Screens mount only once logged in: the API needs a login (middleware/apiAuth.js),
                so they load their data after the login modal, not before it */}
            {props.auth ? (
            <Switch>
              <Route exact path="/" component={Customers}/>
              <Route exact path="/emailAutomation" component={EmailAutomation}/>
              <Route exact path="/tagManager" component={TagManager}/>
              <Route exact path="/cardcomConfig" component={CardcomManagement}/>
              <Route exact path="/admin" component={AdminDashboard}/>
              <Route exact path="/eventTracking" component={EventTracking}/>
              <Route exact path="/whatsapp" component={WhatsappManagement}/>
              <Route exact path="/ai-insert" component={AiInsert}/>
              <Redirect push to='/'/>
            </Switch>
            ) : null}
            </AppLayout>
            <LogIn/>
          </div>
        </BrowserRouter>
      </div>
    </UiProvider>
    );
  }

  const mapStateToProps = state => {
    return {
      auth: state.auth,
      showAlertMessage: state.alert.showAlert,
      alertText: state.alert.alertText
    };
  }
  const mapDispatchToProps = dispatch => bindActionCreators({
    showAlert: actionsCreators.showAlert,
    fetchUser: actionsCreators.fetchUser,
  },dispatch)


  export default connect(mapStateToProps,mapDispatchToProps)(App);
